<template>
  <div class="app flex-row align-items-center">
    <div class="container">
      <b-row class="justify-content-center">
        <b-col md="6">
          <b-card-group>
            <b-card no-body class="p-4">
              <b-card-body>
                <h1>{{ $t("auth.login.login") }}</h1>
                <p class="text-muted">{{ $t("auth.login.loginSubtitle") }}</p>
                <b-input-group class="mb-3">
                  <b-input-group-prepend>
                    <b-input-group-text><i class="icon-user"></i></b-input-group-text>
                  </b-input-group-prepend>
                  <input type="text" v-model="form.username" class="form-control" :placeholder="$t('auth.login.login')" required>
                </b-input-group>
                <b-input-group class="mb-4">
                  <b-input-group-prepend>
                    <b-input-group-text><i class="icon-lock"></i></b-input-group-text>
                  </b-input-group-prepend>
                  <input type="password" v-model="form.password" class="form-control" :placeholder="$t('auth.login.password')" required>
                </b-input-group>
                <b-row>
                  <b-col cols="6">
                    <b-button id="loginBtn" variant="primary" class="px-4" @click="login">{{ $t("auth.login.login") }}</b-button>
                  </b-col>
                  <b-col cols="6" class="text-right">
                    <b-button variant="link" class="px-0" @click="forgetPassword">{{ $t("auth.login.forgetPassword") }}</b-button>
                  </b-col>
                </b-row>
              </b-card-body>
            </b-card>
          </b-card-group>
        </b-col>
      </b-row>
    </div>
  </div>
</template>
<script>
import Cookies from 'js-cookie'
import API from '@/api/api.js'


const accounts={
  'adminDEV':{
    password:'BIAdmin123',
    role:'A',
  },
   'admin':{
    password:'BIAdmin123',
    role:'A',
  },
  'merchant01':
{
    password:'BIMerchant01',
    role:'M',
},

};


export default {
  name: 'Login',
  data() {
    return {
      form: {
        username: '',
        password: ''
      },
      api: new API(),
    }
  },
  methods: {
    checkoutRole(role) {
      // if (!role) {
      //   this.logout();
      // }
      let permissionLevel = -1;
      switch (role) {
        // case "client":
        //   permissionLevel = 7;
        //   break;
        // case "assistant":
        //   permissionLevel = 6;
        //   break;
        case "M":
          permissionLevel = 5;
          break;
        case "A":
          permissionLevel = 0;
          break;

      }
      Cookies.set('permissionLevel', permissionLevel);
      this.$store.commit('setRole', { role: role, level: permissionLevel });
    },
    login() {
      // console.debug('login');
      this.$store.dispatch('Auth/login', this.form)
        .then((json) => {
          Cookies.set('token', json.data.token);
          Cookies.set('role', json.data.role);
          Cookies.set('username', json.data.username);
          this.checkoutRole(json.data.role);
          // location.reload();
          // console.debug(json.data.token);
          // console.debug(this.axios.defaults);
          this.axios.defaults.headers.common['Authorization'] = json.data.token;
          this.$router.replace(this.$route.query.redirect || '/dashboard')
        })
        .catch((err) => {
          console.debug(err);
        });
      // let username = this.form.username;
      // if(this.form.password == accounts[username].password)
      // {
      //   let token="eyJ0eXAiOiJKV1QiLCJhbGciOiJIUzI1NiJ9.eyJpc3MiOiJsb2NhbGhvc3QiLCJpYXQiOjE1Mzk1MzAwNDcsImV4cCI6MTUzOTYxNjQ0NywidXNlcklEIjoiNDUiLCJ1c2VyQ29kZSI6IkEwMjIyMzIxIiwidXNlcm5hbWUiOiJ3aWxsQGZ0aW5ub3RlY2guY29tIiwidXNlclR5cGUiOiJBIiwidXNlckVudGl0eUlEIjoiNDAiLCJBIjp7IklEIjoiNDAiLCJhZ2VudENvZGUiOiJBMDAwMDAwMjkiLCJhZ2VudFRlYW0iOm51bGwsInBvc2l0aW9uIjoiTUEiLCJhZ2VudFR5cGUiOiJBRCJ9LCJyb2xlIjpbInJvb3QiXSwicGVybWlzc2lvbnMiOltdLCJsYW5ndWFnZSI6IiJ9.EVdts7NsAhTQgPrvm6r7YsJeCea77C4dmxYy9q2ImAY";

      //   let role = accounts[username].role;
      //   Cookies.set('token', token);
      //   Cookies.set('role', role);
      //   this.checkoutRole(role);
      //   this.$store.commit('setUsername', { username: username});
      //   Cookies.set('username', username);

      //   this.axios.defaults.headers.common['Authorization'] =  token
      //   this.$router.replace('/dashboard');

      // }else{
      //   alert("賬號或密碼錯誤，請稍後再試");
      // }




    },
    forgetPassword() {
      this.$router.push('/forgetPassword');
    },
    pressEnter(ev) {
      if (ev.charCode === 13) {
        this.login();
      }
    }
  },
  created() {
    if (Cookies.get('token')) {
      if (Cookies.get('role') === 'client') {
        this.$router.replace('/customer-dashboard')
      } else {
        this.$router.replace('/dashboard');
      }
    }
  },
  mounted() {
    window.addEventListener("keypress", this.pressEnter);
  },
  destroyed() {
    window.removeEventListener("keypress", this.pressEnter);
  }
}

</script>



// WEBPACK FOOTER //
// src/Auth/components/Login.vue